import cx from "classnames";
import React from "react";

import { FilterType, ProductEntity } from "@/mk2/apps/bazaar/schemas";
import { bzCategoryUrl } from "@/mk2/apps/bazaar/urlsWithFilter";
import { Link } from "@/mk2/components/Link";
import * as allProps from "@/mk/autogenerated/bzProps";
import { dict as CategoriesDict } from "@/mk/bazaar/product/categories";
import {
    PRODUCT_FACET_LABELS,
    cleanFacetValue,
    filterByCategoryAndProps,
} from "@/mk/bazaar/product/filter/filterUtils";

import styles from "./ProductFacetList.mscss";

interface OwnProps {
    className?: string;
    product: ProductEntity;
}

type Props = OwnProps;

const ProductFacetList: React.FunctionComponent<Props> = ({ className, product }) => {
    const categoryProperty = product.properties.find((p) => p[0] === "cat");
    const categoryName = categoryProperty[1];

    return (
        <div className={cx(styles.ProductFacetList, className)}>
            {product.properties.map((prop, i) => {
                if (prop[0] === "cat") {
                    return null;
                }
                const facetValue = prop[1];
                const facetLabel = prop[0];
                const allPropsOfCat = allProps[categoryName];
                const propInAllPropsOfCat = allPropsOfCat ? allPropsOfCat[facetLabel] : null;
                const thisProp = propInAllPropsOfCat
                    ? propInAllPropsOfCat.find((a) => a[0] === facetValue)
                    : null;

                if (thisProp && thisProp[1]) {
                    const props = {};
                    props[facetLabel] = [facetValue];
                    const catFilter = filterByCategoryAndProps(categoryName, props);
                    const url = bzCategoryUrl(
                        CategoriesDict()[categoryName].slug,
                        catFilter,
                        FilterType.BAZAAR,
                    );

                    let propName = thisProp[1];

                    // cleaning labels and values
                    if (Object.keys(PRODUCT_FACET_LABELS.cots).includes(facetLabel)) {
                        propName =
                            PRODUCT_FACET_LABELS.cots[facetLabel] + cleanFacetValue(facetValue);
                    } else if (Object.keys(PRODUCT_FACET_LABELS).includes(facetLabel)) {
                        propName = PRODUCT_FACET_LABELS[facetLabel][facetValue];
                    }

                    if (!propName) {
                        return null;
                    } else {
                        return (
                            <React.Fragment key={i}>
                                <Link className={styles.ProductFacetList__pill} to={url}>
                                    {propName}
                                </Link>{" "}
                            </React.Fragment>
                        );
                    }
                } else {
                    /* prop or category not defined in all props */
                    return (
                        <React.Fragment key={i}>
                            <span className={styles.ProductFacetList__pill}>
                                {prop[2] ? prop[2] : prop[1]}
                            </span>{" "}
                        </React.Fragment>
                    );
                }
            })}
        </div>
    );
};

ProductFacetList.displayName = "ProductFacetList";

export default React.memo<Props>(ProductFacetList);
